/*
 * @Author: bobo 350910378@qq.com
 * @Date: 2022-05-16 20:54:38
 * @LastEditors: bobo 350910378@qq.com
 * @LastEditTime: 2023-04-18 18:20:41
 * @FilePath: \baishu_react_ui\src\components\dashboard\BsyDashboardCustomApp\index.jsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import React, { Component } from "react";
import BsyRadioGroup from "../../BsyRadioGroup";
import { BsyUtils } from '../../../utils/Utils';
import BsyAlertMenu from "../../BsyAlertMenu";
import BsyGroupList from "../../BsyGroupList";
import BsySwitchBtn from "../../BsySwitchBtn";
import BsyDialog from "../../BsyDialog";
import BsyBubble from "../../BsyBubble";

import BsyDashboardSpeedyEntryConfig from "../BsyDashboardSpeedyEntryConfig";
import BsyDesignSetIconPane from "../BsyDesignSetIconPane";
import ExternalUrlContent from "./externalUrlContent"
import { sortableContainer, sortableElement } from 'react-sortable-hoc';
import { arrayMoveImmutable } from 'array-move';
import './index.css';
import emptySpeedy from "../../../images/img_tianjiashuxing.png";
import tipAlert from "../../../Login/BsyAlertTip/Staticize";

const SortableItem = sortableElement((props) => (
    <>{props.children}</>
));

const SortableContainer = sortableContainer(({ children, draggingIndex }) => {
    return <div className={'group-box'}>{children}</div>;
});

export default class BsyDesignSpeedyEntryConfig extends Component {
    static defaultProps = {
        layoutStyle: "list",
        title: "",
        dataList: [],
        speedyEntry: {}
    }

    constructor(props) {
        super(props);
        const dataListMap = {};
        props.dataList.map((data, index) => {
            data.iconType = data.iconType || data.type;
            data.customName = data.customName || data.name || data.appname
            dataListMap[data._id] = { ...data, customName: (data.customName || data.name || data.appname || "") };
        })
        this.state = {
            dataList: props.dataList,
            dataListMap: dataListMap,
            speedyEntry: props.speedyEntry,
            selectedId: "",
            title: props.title || React.language("speedy.entry"),
            layoutStyle: props.layoutStyle,
            titleMenuSelected: "component",
            changeIcon: {},
            urlBlur: false,
            slidePaneRef: props.slidePaneRef
        }
    }

    componentDidMount() {
        this.BsyDesignSpeedyContext = this.props.BsyDesignSpeedyContext;
        this.props.BsySlideContext && this.props.BsySlideContext(this);
    }

    titleMenuList = [{
        name: React.language("speedy.entry.tab.component"),
        id: "component"
    }, {
        name: React.language("speedy.entry.tab.entryItem"),
        id: "entryItem"
    }]

    speedyEntryDataListMap = []
    speedyEntryDataList = []

    SpeedyEntryValue = (e) => {
        const dataListMap = {};
        e.entries.map((data, index) => {
            data.iconType = data.iconType || data.type;
            dataListMap[data._id] = data;
        })
        this.speedyEntryDataListMap = dataListMap;
        this.speedyEntryDataList = e.entries;
    }

    openAddSpeedyPane = (e) => {
        this.speedyEntryDataList = this.state.dataList;
        this.speedyEntryDataListMap = this.state.dataListMap;
        let menu = [{
            text: React.language("app.form"),
            icon: "icon-bsy-logo",
            iconColor: "#333333",
            click: () => {
                BsyDialog({
                    title: React.language('speedy.entry.add.title'),
                    height: 600,
                    width: 720,
                    noFooter: false,
                    okText: React.language("ok"),
                    cancelText: React.language("cancel"),
                    onOk: () => {
                        const speedyEntry = this.state.speedyEntry;
                        speedyEntry.entries = this.speedyEntryDataList;
                        this.setState({ dataList: this.speedyEntryDataList, dataListMap: this.speedyEntryDataListMap, speedyEntry: speedyEntry })
                    },
                    onContentCreate: () => {
                        return <BsyDashboardSpeedyEntryConfig
                            speedyEntry={this.state.speedyEntry}
                            getValue={this.SpeedyEntryValue}
                        />;
                    }
                })
            }
        }, {
            text: React.language("data.submitPrompt.href.externalUrl"),
            icon: "icon-bsy-nlink",
            iconColor: "#333333",
            click: () => {
                BsyDialog({
                    title: React.language('add') + React.language('data.submitPrompt.href.externalUrl'),
                    height: 600,
                    width: 520,
                    noFooter: false,
                    okText: React.language("ok"),
                    cancelText: React.language("cancel"),
                    onOk: () => {
                        const { dataList, dataListMap } = this.state;
                        const { customUrl, style, iconType, openMode, customName, imageUrl, _id, appType } = this.externalUrlContext.state;
                        if (customName === "") {
                            tipAlert({
                                type: "warning",
                                msg: '请输入名称',
                            });
                            return !1
                        }
                        if (customUrl === "" || (!!customUrl && !this.isLooselyValidURL(customUrl))) {
                            tipAlert({
                                type: "warning",
                                msg: '请输入合规的链接地址',
                            });
                            return !1
                        }
                        let urlApp = {
                            customUrl, style, iconType, openMode, customName, imageUrl, _id, appType
                        }
                        let nDataList = [...dataList, urlApp];
                        let nDataListMap = { ...dataListMap, [_id]: urlApp }
                        const speedyEntry = this.state.speedyEntry;
                        speedyEntry.entries = nDataList;
                        this.setState({ dataList: nDataList, dataListMap: nDataListMap, speedyEntry: speedyEntry })
                    },
                    onContentCreate: () => {
                        return <ExternalUrlContent getContext={this.getExternalUrlContext} />
                    }
                })
            }
        }]
        BsyAlertMenu({
            customCls: 't-speedyEntryV2-dailog',
            item: menu,
            // renderEl: e.currentTarget,
            width: 180,
            target: e.currentTarget,

        })
    }

    getExternalUrlContext = (e) => {
        this.externalUrlContext = e;
    }

    closePan = () => {
        this.props.emitClosePan()
        // if(this.state.title === JSON.parse(this.props.oldData).title && this.state.layoutStyle === JSON.parse(this.props.oldData).layoutStyle && JSON.stringify(this.state.dataList) === JSON.stringify(JSON.parse(this.props.oldData).entries)){
        //     return false
        //   }else{
        //     BsyAlert({
        //       title: React.language("contact.dailog.over.title"),
        //       msg: React.language("contact.dailog.over.tip"),
        //       type: "warning",
        //       text4Ok: React.language("ok"),
        //       OkType: "red",
        //       text4Cancel: React.language("cancel"),
        //       ok: () => {
        //         speedyEntryV2ref.closeAlterMyApp();
        //       }
        //     })
        //     return true
        //   }
        // BsyAlert({
        //     title: React.language("contact.dailog.over.title"),
        //     msg: React.language("contact.dailog.over.tip"),
        //     type: "warning",
        //     text4Ok: React.language("ok"),
        //     OkType: "red",
        //     text4Cancel: React.language("cancel"),
        //     ok: () => {
        //         this.props.getSlideContext && this.props.getSlideContext.onRemoveRoot && this.props.getSlideContext.onRemoveRoot();
        //     }
        //   })
    }

    savePan = () => {
        if (this.state.dataList.length > 50) {
            tipAlert({
                type: "warning",
                msg: '最多50个',
            });
            return
        }
        this.BsyDesignSpeedyContext.saveSpeedyEntry();
        this.props.getSlideContext && this.props.getSlideContext.onRemoveRoot && this.props.getSlideContext.onRemoveRoot();
    }
    pupumPane = (data) => {
        this.setState({ selectedId: data._id, titleMenuSelected: "entryItem" })
    }

    groupNodeClick = (data) => {
        this.setState({ selectedId: data._id })
    }

    groupNodeMove = (attr) => {
        const customGroup = [...this.state.dataList];
        const groupList = this.reorder(
            customGroup,
            attr.source.index,
            attr.destination.index
        );
        const outsiders = [...groupList];
        // this.props.outsiders = groupList;

        let data = {
            "id": attr.draggableId,  //被移动的成员
            "prev": attr.destination.index === 0 ? "" : outsiders[attr.destination.index - 1]._id
        }
        const speedyEntry = this.state.speedyEntry;
        speedyEntry.entries = outsiders;
        this.setState({
            speedyEntry: speedyEntry,
            dataList: outsiders
        });
    }

    reorder = (list, startIndex, endIndex) => {
        const result = Array.from(list);
        // const first = result.splice(0, 1);
        const [removed] = result.splice(startIndex, 1);
        result.splice(endIndex, 0, removed);
        return result;
    };

    onSortEnd = (data) => {
        const { oldIndex, newIndex } = data;
        const { dataList } = this.state;
        const scr = arrayMoveImmutable(dataList, oldIndex, newIndex);
        const speedyEntry = this.state.speedyEntry;
        speedyEntry.entries = scr;
        this.setState({
            speedyEntry: speedyEntry,
            dataList: scr
        })
    };

    eventCustMent = (t, n) => {
        return () => {
            const { dataList } = this.state;
            switch (t) {
                case "set": {
                    this.pupumPane(n)
                    break;
                }
                case "del": {
                    let newList = [];
                    dataList.map(res => {
                        res._id !== n._id && newList.push(res);
                        return !1;
                    })
                    const dataListMap = {};
                    newList.map((data, index) => {
                        data.iconType = data.iconType || data.type;
                        dataListMap[data._id] = data;
                    })
                    const speedyEntry = this.state.speedyEntry;
                    speedyEntry.entries = newList;
                    this.setState({ speedyEntry: speedyEntry, dataList: newList, dataListMap })
                    break;
                }
                default: {

                }
            }
        }
    }

    sourceText = () => {
        const { selectedId, dataListMap } = this.state;
        const item = dataListMap[selectedId];
        switch (item.type) {
            case "report": {
                return React.language('dash') + ": " + (item.name || item.appname);
            }
            case "form": {
                return React.language('form') + ": " + (item.name || item.appname);
            }
            case "dash": {
                return React.language("dash.report") + ": " + (item.name || item.appname);
            }
            case "scenes": {
                return React.language('scenes.report') + ": " + (item.name || item.appname);
            }
            case "app": {
                return React.language('app') + ": " + (item.name || item.appname);
            }
            default: {

            }
        }
    }

    _appEditStyle = (event, data) => {
        data.style = data.style ? data.style : {};
        this.oldIcon = {
            type: data.type,
            icon: data.icon,
            iconType: data.iconType,
            style: data.style,
        };
        BsyBubble({
            width: 360,
            height: 600,
            leftOffset: -50,
            target: event,
            getContext: (e) => {
                this.bubbleContext = e;
            },
            onContentCreate: () => {
                return <BsyDesignSetIconPane
                    selectColor={data.style.color}
                    selectIcon={data.style.icon}
                    imageIcon={data.imageUrl}
                    setType={data.iconType}
                    setChange={this.iconChange}
                    onOk={this.iconOk}
                    onCancel={this.iconCancel}
                />;
            },
            onClose: () => {
                const { selectedId, dataListMap, dataList } = this.state;
                let nData = [...dataList];
                let nData1 = [];
                dataListMap[selectedId] = { ...dataListMap[selectedId], ...this.oldIcon };
                nData1 = nData.map(res => {
                    if (res._id === selectedId) {
                        res = dataListMap[selectedId]
                    }
                    return res
                })
                const speedyEntry = this.state.speedyEntry;
                speedyEntry.entries = nData1;
                this.setState({ dataListMap, dataList: nData1, speedyEntry: speedyEntry })
            }
        })
    }

    oldIcon = {}

    iconChange = (e) => {
        const { selectedId, dataListMap } = this.state;
        let nMap = { ...dataListMap }
        nMap[selectedId].iconType = e.setType;

        if (e.setType === "system") {
            // nMap[selectedId].style = {
            //     icon: nMap[selectedId].style.icon,
            //     color: e.selectColor,
            //     newIcon:e.selectIcon
            // }
            nMap[selectedId].style = {}
            nMap[selectedId].style.icon = nMap[selectedId].icon || nMap[selectedId].style.icon
            nMap[selectedId].style.color = e.selectColor
            nMap[selectedId].style.newIcon = e.selectIcon
        } else {
            nMap[selectedId].imageUrl = e.cropResult;
        }

        this.setState({ dataListMap: nMap })
    }

    dataURLtoBlob = (t) => {
        for (var e = t.split(","), i = e[0].match(/:(.*?);/)[1], a = atob(e[1]), n = a.length, s = new Uint8Array(n); n--;)
            s[n] = a.charCodeAt(n);
        return new Blob([s], {
            type: i
        })
    }

    _createPngName = () => {
        let time = new Date().getTime() - 0;
        return "headTitle_" + time++ + ".png"
    }

    iconOk = () => {
        const { selectedId, dataListMap, dataList } = this.state;
        if (dataListMap[selectedId].iconType === "image") {
            let f = {
                file: this.dataURLtoBlob(dataListMap[selectedId].imageUrl),
                fileName: this._createPngName()
            };

            let formData = new FormData();
            formData.append("file", f.file, f.fileName);
            formData.append("m", 'dashboard');

            React.axios('/dashboard/uploadappico', formData).then(res => {
                let da = res.data.data, str = React.language('icon.replacement.failed');
                let tx = 'warning';
                if (da.success > 0) {
                    tx = "success";
                    str = React.language('icon.replacement.successful');
                    const { selectedId, dataListMap } = this.state;
                    let nMap = { ...dataListMap }
                    nMap[selectedId].imageUrl = da.avatar;

                    this.setState({ dataListMap: nMap })
                }
                tipAlert({
                    type: tx,
                    msg: str
                });
                this.bubbleContext.onRemoveRoot();
            }).catch(res => {
                tipAlert({
                    type: 'warning',
                    msg: React.language('System.error')
                });
                this.bubbleContext.onRemoveRoot();
            })
        } else {
            dataList.map(res => {
                if (dataList._id === selectedId) {
                    res = dataListMap[selectedId]
                }
                return !1
            })
            const speedyEntry = this.state.speedyEntry;
            speedyEntry.entries = dataList;
            this.setState({ dataList: dataList, speedyEntry: speedyEntry }, () => {
                this.bubbleContext.onRemoveRoot();
            })
        }
    }

    iconCancel = () => {
        this.bubbleContext.onRemoveRoot(() => {
            const { selectedId, dataListMap, dataList } = this.state;
            let nData = [...dataList];
            let nData1 = [];
            dataListMap[selectedId] = { ...dataListMap[selectedId], ...this.oldIcon };
            nData1 = nData.map(res => {
                if (res._id === selectedId) {
                    res = dataListMap[selectedId]
                }
                return res
            })
            const speedyEntry = this.state.speedyEntry;
            speedyEntry.entries = nData1;
            this.setState({ dataListMap, dataList: nData1, speedyEntry: speedyEntry })
        });
    }
    curWsutchIconChoose = () => {
        // const { selectedId, dataListMap, dataList } = this.state;
        // let nData = [...dataList];
        // let nData1 = [];
        // dataListMap[selectedId] = {...dataListMap[selectedId], ...this.oldIcon};
        // nData1 = nData.map(res=>{
        //     if(res._id === selectedId){
        //         res = dataListMap[selectedId]
        //     }
        //     return res
        // })
        // const speedyEntry = this.state.speedyEntry;
        // speedyEntry.entries = nData1;
        // this.setState({dataListMap, dataList: nData1, speedyEntry: speedyEntry})
    }
    setIcon = (data) => {
        if ((data.customIconSwitch && data.style.newIcon)) {
            return data.style.newIcon
        } else if (data.customUrl) {
            return data.style.newIcon || data.style.icon
        } else {
            return data.style.icon
        }
    }
    isLooselyValidURL = (url) => {
        const urlPattern = /^(https?:\/\/)?([\w.-]+\.[a-z]{2,6})(\/[\w.-]*)*\/?(\?[\w%&=.-]*)?(#[\w-]*)?$/i;
        return urlPattern.test(url);
    }

    oldUrl = ""

    render() {
        const { titleMenuSelected, layoutStyle, dataList, title, selectedId, dataListMap, urlBlur } = this.state;
        const boxWidth = document.querySelector('#bby').clientWidth - 300;
        const totalMargin = boxWidth % 180;
        const numMargin = totalMargin / parseInt(boxWidth / 180) / 2;
        return (

            <div className={"BsyDesignSpeedyEntryConfig"}>
                <div className="design-config-content">
                    <div className="config-left-content">
                        {
                            dataList && dataList.length > 0 && <div className={`speedy-entry-box`}>
                                <SortableContainer
                                    axis={'xy'}
                                    distance={10}
                                    useDragHandle={false}
                                    getHelperDimensions={e => { return { width: e.node.offsetWidth, height: e.node.offsetHeight } }}
                                    onSortEnd={e => { this.onSortEnd(e) }}
                                >
                                    {
                                        dataList.map((data, index) => {
                                            return <SortableItem key={`item-${index}`} index={index} value={data} >
                                                <a className={`speedy-entry-item ${selectedId === data._id ? `select` : ``} ${layoutStyle}`} style={{ "margin": `7px ${numMargin}px` }}
                                                    onClick={e => { e.stopPropagation(); this.pupumPane(data) }}
                                                    key={'speedy-entry-box-' + index}
                                                >
                                                    <div className="item-cont">
                                                        {
                                                            (data.iconType === "form" || data.iconType === "report" || data.iconType === "dash" || data.iconType === "scenes" || !data.customIconSwitch) && !data.customUrl && data.type !== "app" && <>
                                                                <i className={'entry-icon 1 ' + BsyUtils.getFormIcon(data)} />
                                                                <span className={'entry-title'}>{data.customName || data.appname || data.name}</span>
                                                            </>
                                                        }
                                                        {
                                                            (data.iconType === "app" || data.iconType === "url") && data.customIconSwitch && <>
                                                                <div className={"app-icon 2 color-cover-" + data.style.color}><div className={"imgbg-bsy-app imgbg-bsy-app-" + this.setIcon(data)} /></div>
                                                                <span className="app-name">{data.customName || data.appname || data.name}</span>
                                                            </>
                                                        }
                                                        {
                                                            ((data.iconType === "system" && data.customIconSwitch) || data.customUrl) && data.iconType !== "image" && <>
                                                                <div className={"app-icon 3 color-cover-" + data.style.color}><div className={"imgbg-bsy-app imgbg-bsy-app-" + this.setIcon(data)} /></div>
                                                                <span className="app-name">{data.customName || data.appname || data.name}</span>
                                                            </>
                                                        }
                                                        {
                                                            ((data.type === "app" && !data.customIconSwitch && data.parent === "default")) && <>
                                                                <div className={"app-icon 4 color-cover-" + data.style.color}><div className={"imgbg-bsy-app imgbg-bsy-app-" + data.style.icon} /></div>
                                                                <span className="app-name">{data.customName || data.appname || data.name}</span>
                                                            </>
                                                        }
                                                        {
                                                            ((data.type === "app" && !data.customIconSwitch && data.parent !== "default")) && data.iconType !== "image" && <>
                                                                <div className={"app-icon 5 color-cover-" + data.style.color}><div className={"imgbg-bsy-app imgbg-bsy-app-" + this.setIcon(data)} /></div>
                                                                <span className={'entry-title'}>{data.customName || data.appname || data.name}</span>
                                                            </>
                                                        }
                                                        {
                                                            (data.iconType === "image") && <>
                                                                <div className={`img-bg`} style={{ backgroundImage: `url(${data.imageUrl})`, backgroundSize: "100%" }}></div>
                                                                <span className="app-name">{data.customName || data.appname || data.name}</span>
                                                            </>
                                                        }
                                                    </div>
                                                </a>
                                            </SortableItem>
                                        })
                                    }
                                </SortableContainer>
                            </div>
                        }
                        {
                            dataList.length <= 0 && <div className={`speedy-empty-box`}>
                                <div className={`empty-box`}>
                                    <img src={emptySpeedy} alt="" />
                                    <span>{React.language('speedyEntry.empty.tip')}</span>
                                </div>
                            </div>
                        }

                    </div>
                    <div className="config-right-content">
                        <div className="config-menu">
                            {
                                this.titleMenuList.map(res => {
                                    return <div className={`menu-item ${titleMenuSelected === res.id ? `selected` : ``}`} onClick={() => { this.setState({ titleMenuSelected: res.id }) }} >
                                        <span>{res.name}</span>
                                    </div>
                                })
                            }
                        </div>
                        <div className="config-content">
                            {titleMenuSelected === "component" && <>
                                <div className="cont-item">
                                    <div className="item-title">
                                        <div className="title-text">
                                            <span>{React.language("title")}</span>
                                        </div>
                                    </div>
                                    <div className="item-box"><input type='text' style={{ borderRadius: "4px" }} value={title} onChange={(e) => {
                                        this.setState({ title: e.target.value })
                                    }} /></div>
                                </div>
                                <div className="cont-item">
                                    <div className="item-title">
                                        <div className="title-text">
                                            <span>{React.language("speedy.entry.displayStyle")}</span>
                                        </div>
                                    </div>
                                    <div className="item-box">
                                        <BsyRadioGroup
                                            layout={'horizontal'}
                                            value={layoutStyle}
                                            items={[{
                                                value: 'list',
                                                text: React.language("label.list"),
                                            }, {
                                                value: 'card',
                                                text: React.language("widget.card"),
                                            }]}
                                            onStopEdit={(e) => {
                                                this.setState({
                                                    layoutStyle: e,
                                                })
                                            }}
                                        />
                                    </div>
                                </div>
                                <div className="cont-item">
                                    <div className="item-title">
                                        <div className="title-text">
                                            <span>{React.language("speedy.entry.entryList")}</span>
                                        </div>
                                    </div>
                                    <div className="item-box">
                                        <div className="add-speedy-btn" onClick={this.openAddSpeedyPane}>
                                            <i className="icon-add"></i>
                                            <span>{React.language("speedy.entry.add.entry")}</span>
                                        </div>
                                    </div>

                                    <div className="speedy-entry-list speedy-entry-list-right">
                                        <BsyGroupList
                                            groups={dataList}
                                            hasCustom={false}
                                            nodeSort={(attr) => this.groupNodeMove(attr)}
                                            keyid={'_id'}
                                            nodeMoreOperate={(e, node) => this.groupMoreOperate(e, node)}
                                            hasDeletedList={false}
                                            sortable={true}
                                            hasMenu={false}
                                            customOperate={(item) => {
                                                return <div className="customOperate">
                                                    <i className={'icon-bsy-reportmenu-1'} onClick={this.eventCustMent('set', item)} />
                                                    <i className={'icon-trasho'} onClick={this.eventCustMent('del', item)} />
                                                </div>
                                            }}
                                            customIcon={(data) => {
                                                return <>
                                                    {
                                                        (data.iconType === "form" || data.iconType === "report" || data.iconType === "dash" || data.iconType === "scenes" || !data.customIconSwitch) && !data.customUrl && data.type !== "app" && <>
                                                            <i className={'entry-icon 1 ' + BsyUtils.getFormIcon(data)} />
                                                        </>
                                                    }
                                                    {
                                                        (data.iconType === "app" || data.iconType === "url") && <>
                                                            <div className={"app-icon 2 color-cover-" + data.style.color}><div className={"imgbg-bsy-app imgbg-bsy-app-" + data.style.icon} /></div>
                                                        </>
                                                    }
                                                    {
                                                        ((data.iconType === "system" && data.customIconSwitch) || data.customUrl) && data.iconType !== "image" && <>
                                                            <div className={"app-icon 3 color-cover-" + data.style.color}><div className={"imgbg-bsy-app imgbg-bsy-app-" + this.setIcon(data)} /></div>
                                                        </>
                                                    }
                                                    {
                                                        ((data.type === "app" && !data.customIconSwitch && data.iconType === "system")) && <>
                                                            <div className={"app-icon 4 color-cover-" + data.style.color}><div className={"imgbg-bsy-app imgbg-bsy-app-" + data.style.icon} /></div>

                                                        </>
                                                    }
                                                    {
                                                        (data.iconType === "image") && <>
                                                            <div className={`img-bg`} style={{ marginRight: 6, width: 16, height: 16, backgroundImage: `url(${data.imageUrl})`, backgroundSize: "100%" }}></div>
                                                        </>
                                                    }
                                                </>
                                            }}
                                            // splitMenuIcon={'icon-bsy-iconputongguanlizu'}
                                            splitMenuName={React.language('manager.normal')}
                                        />
                                    </div>
                                </div>
                            </>}
                            {titleMenuSelected === "entryItem" && <>
                                {
                                    !selectedId && <div className="noSelectEntry">
                                        <div className="empty-text">
                                            <span>{React.language("speedy.entry.tab.entryItem.emptyTip")}</span>
                                        </div>
                                    </div>
                                }
                                {
                                    selectedId && dataListMap[selectedId].appType !== "url" && <>
                                        <div className="cont-item">
                                            <div className="item-title">
                                                <div className="title-text">
                                                    <span>{React.language("speedy.entry.entryItem.source")}</span>
                                                </div>
                                            </div>
                                            <div className="item-box">
                                                <span className="source">
                                                    {
                                                        this.sourceText()
                                                    }
                                                </span>
                                            </div>
                                        </div>
                                        <div className="cont-item">
                                            <div className="item-title">
                                                <div className="title-text">
                                                    <span>{React.language("print.file.name.custom")}</span>
                                                </div>
                                                <BsySwitchBtn power={dataListMap[selectedId].customNameSwitch} switchChange={(e) => {
                                                    dataList.map(res => {
                                                        if (res._id === selectedId) {
                                                            res.customNameSwitch = e;
                                                        }
                                                        if (!e) {
                                                            res.customName = res.name || res.appname;
                                                        }
                                                        dataListMap[res._id] = res;
                                                        return !1
                                                    })
                                                    this.setState({ dataList, dataListMap })
                                                }} />
                                            </div>
                                            <div className="item-box">
                                                {dataListMap[selectedId].customNameSwitch && <input type='text' style={{ borderRadius: "4px" }} maxLength={26}
                                                    value={dataListMap[selectedId].customName}
                                                    onChange={(e) => {
                                                        dataList.map(res => {
                                                            if (res._id === selectedId) {
                                                                res.customName = e.target.value;
                                                            }
                                                            dataListMap[res._id] = res;
                                                            return !1
                                                        })
                                                        this.setState({ dataList, dataListMap })
                                                    }} onBlur={(e) => {
                                                        if (!e.target.value) {
                                                            dataList.map(res => {
                                                                if (res._id === selectedId) {
                                                                    res.customName = res.name || res.appname;
                                                                }
                                                                dataListMap[res._id] = res;
                                                                return !1
                                                            })
                                                            this.setState({ dataList, dataListMap })
                                                        }
                                                    }} />}
                                            </div>
                                        </div>
                                        <div className="cont-item">
                                            <div className="item-title">
                                                <div className="title-text">
                                                    <span>{React.language("speedy.entry.entryItem.customIcon")}</span>
                                                </div>
                                                <BsySwitchBtn power={dataListMap[selectedId].customIconSwitch} switchChange={(e) => {
                                                    dataList.map(res => {
                                                        if (res._id === selectedId) {
                                                            res.customIconSwitch = e;
                                                        }
                                                        dataListMap[res._id] = res;
                                                        return !1
                                                    })
                                                    this.setState({ dataList, dataListMap })
                                                    if (!e) {
                                                        this.curWsutchIconChoose()
                                                    }
                                                }} />
                                            </div>
                                            <div className="item-box">
                                                {
                                                    dataListMap[selectedId].customIconSwitch && <div className="customIconCont" onMouseEnter={(event) => {
                                                        window.FX.UI.showPopover({
                                                            position: "top",
                                                            anchor: window.$(event.target),
                                                            content: window.$("<span/>").text(React.language('change.icon')),
                                                            type: "dark"
                                                        })
                                                    }} onMouseLeave={() => {
                                                        window.FX.UI.closePopover()
                                                    }} onClick={(e) => { this._appEditStyle(e, dataListMap[selectedId]) }}>
                                                        {
                                                            (dataListMap[selectedId].iconType === "form" || dataListMap[selectedId].iconType === "report" || dataListMap[selectedId].iconType === "dash" || dataListMap[selectedId].iconType === "scenes") && <i className={'entry-icon ' + BsyUtils.getFormIcon(dataListMap[selectedId])} />
                                                        }
                                                        {
                                                            (dataListMap[selectedId].iconType === "app" || dataListMap[selectedId].iconType === "url" || dataListMap[selectedId].iconType === "system") && <div className={`app-icon color-cover-${dataListMap[selectedId].style.color}`}>
                                                                <div className={`imgbg-bsy-app imgbg-bsy-app-${this.setIcon(dataListMap[selectedId])}`}></div>
                                                            </div>
                                                        }
                                                        {
                                                            dataListMap[selectedId].iconType === "image" && <div className={`image-icon`}>
                                                                <div className={`img-bg`} style={{ backgroundImage: `url(${dataListMap[selectedId].imageUrl})`, backgroundSize: "100%" }}></div>
                                                            </div>
                                                        }
                                                        <div className="edit-icon">
                                                            <i className="icon-bsy-reportmenu-1"></i>
                                                        </div>

                                                    </div>
                                                }
                                            </div>
                                        </div>
                                        <div className="cont-item">
                                            <div className="item-title">
                                                <div className="title-text">
                                                    <span>{React.language("speedy.entry.entryItem.openType")}</span>
                                                    <i className="icon-shixinhelp" onMouseEnter={(event) => {
                                                        window.FX.UI.showPopover({
                                                            position: "top",
                                                            anchor: window.$(event.target),
                                                            content: window.$("<span style='font-size: 12px' />").text(React.language('speedy.entry.entryItem.openType.tips')),
                                                            // type: "dark"
                                                            edge: 12
                                                        })
                                                    }} onMouseLeave={() => {
                                                        window.FX.UI.closePopover()
                                                    }}></i>
                                                </div>
                                            </div>
                                            <div className="item-box">
                                                <BsyRadioGroup
                                                    layout={'horizontal'}
                                                    value={dataListMap[selectedId].openMode || 'current'}
                                                    items={[{
                                                        value: 'current',
                                                        text: React.language("speedy.entry.entryItem.openType.current"),
                                                    }, {
                                                        value: 'newPage',
                                                        text: React.language("speedy.entry.entryItem.openType.newPage"),
                                                    }]}
                                                    onStopEdit={(e) => {
                                                        dataList.map(res => {
                                                            if (res._id === selectedId) {
                                                                res.openMode = e;
                                                            }
                                                            dataListMap[res._id] = res;
                                                            return !1
                                                        })
                                                        this.setState({ dataList, dataListMap })
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    </>
                                }
                                {
                                    selectedId && dataListMap[selectedId].appType === "url" && <>
                                        <div className="cont-item">
                                            <div className="item-title">
                                                <div className="title-text">
                                                    <span>{React.language("label.name")}</span>
                                                </div>
                                            </div>
                                            <div className="item-box">
                                                <input type='text' style={{ borderRadius: "4px" }} value={dataListMap[selectedId].customName || ""} maxLength={26} onChange={(e) => {
                                                    dataList.map(res => {
                                                        if (res._id === selectedId) {
                                                            res.customName = e.target.value;
                                                        }
                                                        dataListMap[res._id] = res;
                                                        return !1
                                                    })
                                                    this.setState({ dataList, dataListMap })
                                                }} />
                                            </div>
                                        </div>
                                        <div className="cont-item">
                                            <div className="item-title">
                                                <div className="title-text">
                                                    <span>{React.language("link.address")}</span>
                                                </div>
                                            </div>

                                            <div className={`item-box ${(!!dataListMap[selectedId].customUrl && !this.isLooselyValidURL(dataListMap[selectedId].customUrl)) ? "error" : ""}`}>
                                                {(urlBlur && !!dataListMap[selectedId].customUrl && !this.isLooselyValidURL(dataListMap[selectedId].customUrl)) && <div className="item-error-tip">
                                                    <span>{React.language("invalid.url")}</span>
                                                </div>}
                                                <input onBlur={() => {
                                                    if (!!dataListMap[selectedId].customUrl && !this.isLooselyValidURL(dataListMap[selectedId].customUrl)) {
                                                        dataList.map(res => {
                                                            if (res._id === selectedId) {
                                                                res.customUrl = this.oldUrl;
                                                            }
                                                            dataListMap[res._id] = res;
                                                            return !1
                                                        })
                                                        this.setState({ urlBlur: false, dataList, dataListMap })
                                                    } else {
                                                        this.setState({ urlBlur: false })
                                                    }
                                                }} maxLength={26} onFocus={(e) => { this.oldUrl = e.target.value; this.setState({ urlBlur: true }) }} type='text' value={dataListMap[selectedId].customUrl} onChange={(e) => {
                                                    dataList.map(res => {
                                                        if (res._id === selectedId) {
                                                            res.customUrl = e.target.value;
                                                        }
                                                        dataListMap[res._id] = res;
                                                        return !1
                                                    })
                                                    this.setState({ dataList, dataListMap })
                                                }} />
                                            </div>
                                        </div>
                                        <div className="cont-item">
                                            <div className="item-title">
                                                <div className="title-text">
                                                    <span>{React.language("speedy.entry.entryItem.customIcon")}</span>
                                                </div>
                                            </div>
                                            <div className="item-box">
                                                {
                                                    <div className="customIconCont" onMouseEnter={(event) => {
                                                        window.FX.UI.showPopover({
                                                            position: "top",
                                                            anchor: window.$(event.target),
                                                            content: window.$("<span/>").text(React.language('change.icon')),
                                                            type: "dark"
                                                        })
                                                    }} onMouseLeave={() => {
                                                        window.FX.UI.closePopover()
                                                    }} onClick={(e) => { this._appEditStyle(e, dataListMap[selectedId]) }}>
                                                        {
                                                            (dataListMap[selectedId].iconType === "app" || dataListMap[selectedId].iconType === "url" || dataListMap[selectedId].iconType === "system") && <div className={`app-icon color-cover-${dataListMap[selectedId].style.color}`}>
                                                                <div className={`imgbg-bsy-app imgbg-bsy-app-${this.setIcon(dataListMap[selectedId])}`}></div>
                                                            </div>
                                                        }
                                                        {
                                                            dataListMap[selectedId].iconType === "image" && <div className={`image-icon`}>
                                                                <div className={`img-bg`} style={{ backgroundImage: `url(${dataListMap[selectedId].imageUrl})`, backgroundSize: "100%" }}></div>
                                                            </div>
                                                        }

                                                    </div>
                                                }
                                            </div>
                                        </div>
                                        <div className="cont-item">
                                            <div className="item-title">
                                                <div className="title-text">
                                                    <span>{React.language("speedy.entry.entryItem.openType")}</span>
                                                    <i className="icon-shixinhelp" onMouseEnter={(event) => {
                                                        window.FX.UI.showPopover({
                                                            position: "top",
                                                            anchor: window.$(event.target),
                                                            content: window.$("<span/>").text(React.language('speedy.entry.entryItem.openType.tips')),
                                                            type: "dark"
                                                        })
                                                    }} onMouseLeave={() => {
                                                        window.FX.UI.closePopover()
                                                    }}></i>
                                                </div>
                                            </div>
                                            <div className="item-box">
                                                <BsyRadioGroup
                                                    layout={'horizontal'}
                                                    value={dataListMap[selectedId].openMode || 'current'}
                                                    items={[{
                                                        value: 'current',
                                                        text: React.language("speedy.entry.entryItem.openType.current"),
                                                    }, {
                                                        value: 'newPage',
                                                        text: React.language("speedy.entry.entryItem.openType.newPage"),
                                                    }]}
                                                    onStopEdit={(e) => {
                                                        dataList.map(res => {
                                                            if (res._id === selectedId) {
                                                                res.openMode = e;
                                                            }
                                                            dataListMap[res._id] = res;
                                                            return !1
                                                        })
                                                        this.setState({ dataList, dataListMap })
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    </>
                                }
                            </>}
                        </div>
                    </div>
                </div>
                <div className="design-config-footer">
                    <div className="footer-btn cancel" onClick={this.closePan}>
                        <span>{React.language("cancel")}</span>
                    </div>
                    <div className="footer-btn save" onClick={this.savePan}>
                        <span>{React.language("save")}</span>
                    </div>
                </div>
            </div>
        )
    }
}